import React from "react";
import "./Projects.css";
import { projects } from "../data/portfolioData";
import { FaGithub } from "react-icons/fa";
import { HiExternalLink, HiOutlineCube } from "react-icons/hi";

function Projects() {
  return (
    <section id="projects" className="projects-section section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Portfolio</span>
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">
            Distributed backend systems, algorithmic platforms, and generative AI incident workflows.
          </p>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-category-bar">
                <span className="category-label">
                  <HiOutlineCube size={14} />
                  {project.category}
                </span>
                <span className="project-index">0{index + 1}</span>
              </div>

              <h3 className="project-title">{project.title}</h3>

              <p className="project-description">
                {project.description}
                {/* TODO: add verified metric (e.g. latency, throughput, benchmark) */}
              </p>

              {/* Technologies */}
              <div className="project-tech-tags">
                {project.technologies.map((tech, tIdx) => (
                  <span key={tIdx} className="tech-badge">
                    {tech}
                  </span>
                ))}
              </div>

              {/* Card Footer: GitHub Link Placeholder */}
              <div className="project-card-footer">
                <a
                  href={project.githubPlaceholder}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-github-btn"
                  aria-label={`View ${project.title} on GitHub`}
                >
                  <FaGithub size={18} />
                  <span>GitHub Repository</span>
                  <HiExternalLink size={14} className="ext-icon" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
